export default "__VITE_ASSET__DlxbyP9l__"